import React, { useEffect, useState } from "react";
import Modal2 from "../Modal/Modal2";
import Step1 from "./Step1";
import Step2 from "./Step2";
import { Steps, message } from "antd";
import Loader from "../Loader";
import Success from "./Success";
import { useSelector } from "react-redux";
import restService from "../../../services/restService";
import { useToasts } from "react-toast-notifications";
import RestService from "../../../services/rest-service";
import { parsePhoneNumber } from "react-phone-number-input";

const keys = [
  "firstname",
  "lastname",
  "msisdn",
  "country_id",
  "address",
  "agent_role",
  "agency_id",
];
const AddNewAgent = ({ show, refetchData, setShow }) => {
  const { addToast } = useToasts();

  const user = useSelector((state) => state.auth?.user);

  const [current, setCurrent] = useState(0);

  const [form, setForm] = useState({
    firstname: "",
    lastname: "",
    othernames: "",
    email: "",
    calling_code: "",
    msisdn: "",
    country_id: "",
    address: "",
    agent_role: "",
    agency_id: "",
    phone_number_prefix: user?.agency?.country?.iso_3166_2,
  });
  const [confirmation, setConfirmation] = useState(false);
  const [roles, setRoles] = useState([]);
  const [errors, setErrors] = useState({});
  const [countries, setCountries] = useState([]);
  const [agencies, setAgencies] = useState([]);
  const [callback, setCallback] = useState(() => {});
  const [loading, setLoading] = useState(false);
  const [agentAdded, setAgentAdded] = useState(false);

  useEffect(() => {
    restService.UtilsApi.getCountries().then(({ data }) => {
      const callingCode = data?.data.find(
        (country) => country.name === user.country?.name
      )?.calling_code;
      const countryId = data?.data.find(
        (country) => country.name === user.agency?.country?.name
      )?.id;

      restService.AgencyApi.getAgencies().then(({ data: agencyData }) => {
        const agencyId = agencyData?.data?.data?.[0]?.id;

        restService.UtilsApi.getAgentRoles().then(({ data: rolesData }) => {
          const agentRole = rolesData?.data?.[0]?.name;

          setForm((prevForm) => ({
            ...prevForm,
            calling_code: callingCode,
            country_id: countryId,
            agency_id: agencyId,
            agent_role: agentRole,
          }));

          setCountries(data?.data);
          setAgencies(user?.isAdmin ? agencyData?.data?.data : [user?.agency]);
          setRoles(rolesData?.data);
        });
      });
    });
  }, []);

  const next = () => {
    if (validateForm()) {
      setCurrent(current + 1);
    }
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const handleSubmit = (data) => {
    //Api request to save agent
    if (validateForm()) {
      setLoading(true);
      // data.agency_id = user?.agency?.id ;
      restService.AgentApi.addAgent(data)
        .then((response) => {
          addToast("Successfully Added Agent", {
            appearance: "success",
            autoDismiss: true,
            autoDismissTimeout: 5000,
          });
          //  setRedirect(true);
          setAgentAdded(true);
        })
        .catch((err) => {
          addToast("Failed to add agent", {
            appearance: "error",
            autoDismiss: true,
            autoDismissTimeout: 5000,
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const validateForm = () => {
    let errorList = {};
    keys.forEach((key) => {
      // TODO validate phone numbers
      if (!form[key]) {
        errorList[key] = "This field is required.";
      } else {
        delete errorList[key];
        if (key === "email") {
          const regex = /\S+@\S+\.\S+/;
          if (!regex.test(form[key])) {
            errorList[key] = "Enter a valid email.";
          }
        }
      }
    });
    setErrors(errorList);

    return Object.keys(errorList).length === 0;
  };

  const onFormChange = ({ target }) => {
    let details = { ...form };
    details[target.name] = target.value;
    let errorList = errors;
    delete errorList[target.name];
    setErrors(errorList);

    if (target.name === "country_id") {
      const country = countries.filter((c) => c.id === target.value)[0];
      details.calling_code = country?.calling_code;
    }
    setForm(details);
  };

  const countryOptions = countries.map((country) => {
    country.label = `${country.name}`;
    return country;
  });

  const onPhoneNumberChange = (value) => {
    const calling_code = parsePhoneNumber(String(value));
    // let msisdn = value ? value?.trim()?.slice(calling_code?.length + 1) : "";
    // const country = countries.filter(
    //   (c) => c.iso_3166_2 == calling_code?.country
    // )[0];

    setForm({
      ...form,
      calling_code: calling_code?.countryCallingCode ?? "",
      msisdn: value,
    });
  };

  const steps = [
    {
      title: "",
      content: (
        <Step1
          countries={countries}
          errors={errors}
          setForm={setForm}
          onPhoneNumberChange={onPhoneNumberChange}
          onFormChange={onFormChange}
          form={form}
          next={next}
          prev={prev}
          user={user}
          roles={roles}
          agencies={agencies}
        />
      ),
    },
    {
      title: "",
      content: <Step2 data={form} handleSubmit={handleSubmit} prev={prev} />,
    },
  ];

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  return (
    <>
      {loading ? <Loader /> : null}
      <Modal2
        onHide={() => {
          // if (agentAdded) {
          //   setShow(false);
          // }

          setShow(false);
          setCurrent(0);
        }}
        size={agentAdded ? "small" : "lg"}
      >
        {loading ? (
          ""
        ) : (
          <>
            {agentAdded ? (
              <div className="h-[50vh] intro-y flex items-center justify-center">
                <Success />
              </div>
            ) : (
              <div className="bg-gradient-to-br from-blue-50 to-indigo-50 min-h-[70vh]">
                {/* Modern Header */}
                <div className="bg-white border-b border-gray-100 px-8 py-6">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-4">
                      <button
                        className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors duration-200"
                        onClick={() => {
                          if (current === 0) {
                            setShow(false);
                            return;
                          }
                          prev();
                        }}
                      >
                        <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                      </button>
                      <div>
                        <h1 className="text-2xl font-bold text-gray-900">Add New Agent</h1>
                        <p className="text-sm text-gray-500">Create a new agent profile in the system</p>
                      </div>
                    </div>
                    <button
                      onClick={() => setShow(false)}
                      className="flex items-center justify-center w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors duration-200"
                    >
                      <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>

                  {/* Modern Progress Steps */}
                  <div className="mt-8">
                    <div className="flex items-center justify-center max-w-md mx-auto">
                      <div className="flex items-center w-full">
                        <div className={`flex items-center justify-center w-10 h-10 rounded-full border-2 transition-all duration-300 ${
                          current >= 0 ? 'bg-blue-600 border-blue-600 text-white' : 'bg-white border-gray-300 text-gray-400'
                        }`}>
                          {current > 0 ? (
                            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                            </svg>
                          ) : (
                            <span className="text-sm font-semibold">1</span>
                          )}
                        </div>
                        <div className={`flex-1 h-1 mx-4 rounded-full transition-all duration-300 ${
                          current >= 1 ? 'bg-blue-600' : 'bg-gray-200'
                        }`}></div>
                        <div className={`flex items-center justify-center w-10 h-10 rounded-full border-2 transition-all duration-300 ${
                          current >= 1 ? 'bg-blue-600 border-blue-600 text-white' : 'bg-white border-gray-300 text-gray-400'
                        }`}>
                          <span className="text-sm font-semibold">2</span>
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-between max-w-md mx-auto mt-2">
                      <span className={`text-sm font-medium transition-colors duration-300 ${
                        current >= 0 ? 'text-blue-600' : 'text-gray-400'
                      }`}>Personal Details</span>
                      <span className={`text-sm font-medium transition-colors duration-300 ${
                        current >= 1 ? 'text-blue-600' : 'text-gray-400'
                      }`}>Documents</span>
                    </div>
                  </div>
                </div>

                {/* Content Area */}
                <div className="p-8">
                  <div className="max-w-4xl mx-auto">
                    {steps[current].content}
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </Modal2>
    </>
  );
};

export default AddNewAgent;
